<ol>
  @for (position of attachmentsPositions(); track position.tag) {
    <li>
      {{ position.description }}: @if (getAttachmentsByTag(position.tag); as att) {
      <strong *ngIf='!att.length'>brak</strong>
      <ng-container *ngIf='att.length'>
        @for (item of att; track item?.id) {
          <a [title]='"Pobierz " + item?.originalName || ""' href='#'
             (click)='onDownloadFile($event, item?.id, item?.originalName)'>
            <strong>{{ item?.originalName }}</strong>
          </a>@if (!$last) {
            ,
          }
        }
      </ng-container>
    }
    </li>
  }
</ol>
<app-attachment-info [application]="application()"></app-attachment-info>
